import React, { useEffect, useState } from 'react'
import { Box, Button, Checkbox, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import { Item, SuccessPopUp } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { getMacManagement } from '../constants'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { connect } from 'react-redux'
import TableCellTooltip from '../../../common/TableCellTooltip'
import { getAllBranchName, getMacManagementTableData, updateMacManagementStatus } from '../../../../store/branchAndUserMaster/BUMAction'
import { updateAlertError } from '../../../../store/common/common_action'
import { focusElemnt, isEmpty, navigation1 } from '../../../common/helper'
import SuccessAndErrorModal from '../../../common/SuccessAndErrorModal'
import moment from 'moment'
import { useTranslation } from '../../../../i18n/I18nProvider'

const MacManagement = (props) => {
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const macManagement = getMacManagement(translations)
    const { data, updateAlertError, getAllBranchName, getMacManagementTableData, updateMacManagementStatus, loginData } = props
    const { branchAndUserMasterReducer, common } = data
    // const { loginData } = common
    const { MacMgmtTableData } = branchAndUserMasterReducer
    const statusList = [
        { id: 0, name: bum.inActive || 'InActive' },
        { id: 1, name: bum.active || 'Active' },
        { id: -1, name: bum.all || 'All' },
    ]
    const [tableData, setTableData] = useState([])
    const [branchList, setBranchList] = useState([])
    const [status, setStatus] = useState(statusList[1])
    const [branchName, setBranchName] = useState({ id: 0, name: bum.all || "All" })
    useEffect(() => {
        if (translations) {
            const currentStatusOpt = statusList.find(opt => opt.id === status?.id);
            if (currentStatusOpt) {
                setStatus(currentStatusOpt);
            }
            if (branchName?.id === 0) {
                setBranchName({ id: 0, name: bum.all || "All" });
            }
        }
    }, [translations]);
    const [filterValues, setFilterValues] = useState({});
    const [filteredData, setfilteredData] = useState(tableData)
    const [isSuccess, setIsSuccess] = useState(false)
    const [showConfirmation, setShowConfirmation] = useState(false)
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const width = window.innerWidth - 40
    useEffect(() => {
        setTimeout(() => {
            focusElemnt('mmBranchName')
        }, 0)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        if (loginData?.intCompanyID !== 'undefined') {
            const object = {
                CompanyID: loginData?.intCompanyID,
                IsActive: status?.id,
                IsRegistered: 1,
                BranchID: branchName?.id,
            }
            getMacManagementTableData(object)
        } else {

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginData?.intCompanyID])
    const getTableData = () => {
        if (branchName === '' || status === '') {
            updateAlertError({ show: true, msg: bum.pleaseSelectTheFilters || 'Please Select The Filters', success: false, nextId: `maBranchName` })
        } else {
            const object = {
                CompanyID: loginData?.intCompanyID,
                IsActive: status?.id,
                IsRegistered: 1,
                BranchID: branchName?.id,
            }
            getMacManagementTableData(object)
        }
    }
    function customSort(a, b) {
        // Sort by IsActive property
        if (a.IsActive !== b.IsActive) {
            return b.IsActive - a.IsActive;
        }

        // Sort alphabetically by city
        if (a.CityName !== b.CityName) {
            return a.CityName.localeCompare(b.CityName);
        }

        // Sort by branch
        if (a.BranchName !== b.BranchName) {
            return a.BranchName.localeCompare(b.BranchName);
        }

        // Sort alphabetically by location
        return a.LocationCity.localeCompare(b.LocationCity);
    }
    useEffect(() => {
        if (MacMgmtTableData?.length > 0) {
            const data = [...MacMgmtTableData]
            data.sort(customSort)
            let newData = data?.map((val, i) => ({ ...val, isEdited: false }))
            setTableData(newData)
        } else {
            setTableData([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [MacMgmtTableData])
    useEffect(() => {
        setfilteredData(tableData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData])
    useEffect(() => {
        const filteredDataTemp = tableData.filter((item) => {
            return macManagement.every((column) => {
                const filterValue = filterValues[column.field] || "";
                const value = item[column.field]?.toString()
                return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
            })
        })
        setfilteredData(filteredDataTemp)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterValues])
    useEffect(() => {
        if (loginData?.intCompanyID !== 'undefined' && loginData?.intUserID !== 'undefined') {
            getBranchListData()
        } else {

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginData?.intCompanyID])
    const getBranchListData = () => {
        const object = {
            intUserID: loginData?.intUserID,
            intCompanyID: loginData?.intCompanyID,
            intBranchID: 0,
            strBranchName: "",
            strBranchCode: "",
            intStateID: 0,
            intCityID: 0,
            intIsActive: 1
        }
        getAllBranchName(object, true, 24 * 60 * 60 * 1000)?.then((res) => {
            if (res?.status === 'Success') {
                if (res?.Data?.Table?.length < 0) {
                    updateAlertError({ show: true, msg: bum.noDataForBranchList || 'No Data For Branch List', success: false, nextId: `maBranchName` })
                } else {
                    let branches = [{ id: 0, name: bum.all || 'All' }]
                    res?.Data?.Table?.map(obj => branches.push({ name: obj.BranchName, id: obj.BranchID }))
                    branches.sort((a, b) => a.name.localeCompare(b.name));
                    setBranchList(branches)
                    let filteredBranch = branches.filter(branch => branch.id === 0);
                    filteredBranch.length > 0 ? setBranchName(filteredBranch[0]) : setBranchName("")
                }
            } else {
                updateAlertError({ show: true, msg: res.Message, success: false, nextId: `maBranchName` })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    const handleRowChkChange = (e, index) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index].IsActive = e.target.checked ? 1 : 0
            newVal[index].isEdited = !newVal[index].isEdited
            setfilteredData(newVal)
        }

        setTimeout(() => {
            focusElemnt(`ma-chkbox-${index}`)
        }, 0)
    }
    const handleChangeContain = (e, name) => {
        let value = e.target.value;
        setFilterValues((prevFilterValues) => ({
            ...prevFilterValues,
            [name]: value
        }));
    }
    const handleSave = () => {
        let object = {
            EntityIDs: '',
            RequestIDs: '',
            IsActives: '',
            ModifiedByUserID: loginData?.intUserID
        }
        filteredData?.map((val, i) => {
            if (val.isEdited) {
                object.EntityIDs = object?.EntityIDs === '' ? val?.BranchID : object?.EntityIDs + '^' + val?.BranchID
                object.RequestIDs = object?.RequestIDs === '' ? val?.RequestID : object?.RequestIDs + '^' + val?.RequestID
                object.IsActives = object?.IsActives === '' ? val?.IsActive : object?.IsActives + '^' + val?.IsActive
            }
        })
        updateMacManagementStatus(object)?.then((res) => {
            if (res?.status === 'Success') {
                setIsSuccess(true)
            } else {
                updateAlertError({ show: true, msg: res.Message, success: false, nextId: `mmBranchName` })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    const ShowMavenManagementConfirmation = () => {
        const data = {
            successMessage: bum.doYouWantToUpdateTheMacManagementStatusQ || 'Do you want to update the Mac Management Status?',
            otherMessage: '',
            buttonId1: '',
            buttonId2: '',
            headTxt: bum.macManagement || 'Mac Management',
            yesAction: () => { handleSave(); setShowConfirmation(false) },
            noAction: () => setShowConfirmation(false)
        }
        return <SuccessPopUp data={data} updateModal={setShowConfirmation} />
    }
    const handleChkBoxNavigation = (e, nextId, prevId) => {
        if (e.key === 'ArrowUp') {
            focusElemnt(prevId)
        }
        if (e.key === 'ArrowDown') {
            focusElemnt(nextId)
            e.preventDefault()
        }
        if (e.key === 'Enter') {
            focusElemnt('mmSaveBtn')
            e.preventDefault()
        }
    }
    const InsideRowContent = (item, index) => {
        const width = window.innerWidth - 40
        return (
            <TableRow key={`DR-${index}`}>
                <TableCell style={{ minHeight: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>{index + 1}</TableCell>
                <TableCellTooltip
                    placement="bottom-start"
                    textAlign="left"
                    maxWidth={`${Math.ceil((width * macManagement.widthPercent) / 100)}px`}
                    title={item.CityName || ''}
                    data={item.CityName}
                />
                <TableCellTooltip
                    placement="bottom-start"
                    textAlign="left"
                    maxWidth={`${Math.ceil((width * macManagement.widthPercent) / 100)}px`}
                    title={item.BranchName || ''}
                    data={item.BranchName}
                />
                <TableCellTooltip
                    placement="bottom-start"
                    textAlign="left"
                    maxWidth={`${Math.ceil((width * macManagement.widthPercent) / 100)}px`}
                    title={item.GUID || ''}
                    data={item.GUID}
                />
                <TableCellTooltip
                    placement="bottom-start"
                    textAlign="left"
                    maxWidth={`${Math.ceil((width * macManagement.widthPercent) / 100)}px`}
                    title={item.LocationCity || ''}
                    data={item.LocationCity}
                />
                <TableCellTooltip
                    placement="bottom-start"
                    textAlign="left"
                    maxWidth={`${Math.ceil((width * macManagement.widthPercent) / 100)}px`}
                    title={item.ModifiedByUser + ", " + item.ModifiedUserBranch || ''}
                    data={item.ModifiedByUser}
                />
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}>{item.ModifiedDateTime !== "" ? moment(item.ModifiedDateTime).format('HH:mm, DD-MMM-YY') : ""}</TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'center', fontSize: '12px', color: '#666', padding: '0px' }}>
                    <Checkbox id={`mm-checkbox-${index}`} checked={item.IsActive === 1} sx={{ height: '36px' }}
                        onChange={(e) => handleRowChkChange(e, index)}
                        onKeyDown={(e) => {
                            handleChkBoxNavigation(e, index < filteredData?.length - 1 ? `mm-checkbox-${index + 1}` : 'mmSaveBtn', index === 0 ? 'mmSaveBtn' : `mm-checkbox-${index - 1}`)
                        }}
                    />
                </TableCell>
            </TableRow>
        )
    }
    return (
        <>
            <Box sx={{ ...sx.reportFlex, padding: '11px 0px 2px 0px', gap: '10px' }} className="reportButton">
                <Item sx={sx.itemsx}>
                    <DropDownOA id='mmBranchName' label={bum.branchName || 'Branch Name'} minWidth="250px"
                        defaultvalue={branchName?.name || ''}
                        value={branchName?.name || ''}
                        data={branchList || []}
                        dataKey={`name`}
                        idKey={`id`}
                        onSelResetVal={true}
                        onSelect={(value) => {
                            setBranchName(value)
                        }}
                        prevId='mmSaveBtn'
                        nextId='mmStatus'
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        id='mmStatus'
                        label={bum.status || 'Status'}
                        minWidth="250px"
                        defaultvalue={status?.name || ''}
                        value={status?.name || ''}
                        data={statusList || []}
                        dataKey={`name`}
                        idKey={`id`}
                        onSelResetVal={true}
                        onSelect={(value) => {
                            setStatus(value)
                        }}
                        prevId='mmBranchName'
                        nextId='mmLoadBtn'
                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button id='mmLoadBtn' variant="contained"
                        style={{ ...sx.fullHeight, ...sx.novp }}
                        className="btn btn-primary"
                        onClick={() => { getTableData() }}
                        onKeyDown={(e) => {
                            navigation1(e, 'mmSaveBtn', 'mmStatus');
                        }}
                    >
                        {bum.load || 'LOAD'}
                    </Button>
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button id='mmSaveBtn' variant="outlined"
                        style={{ height: '40px' }} color="secondary"
                        onClick={() => setShowConfirmation(true)}
                        onKeyDown={(e) => {
                            navigation1(e, filteredData?.length > 0 ? 'mm-checkbox-0' : 'mmBranchName', 'mmLoadBtn');
                        }}
                    >
                        {bum.saveUpper || 'SAVE'}
                    </Button>
                </Item>
            </Box>
            <Box sx={{ margin: '16px 0px 0px 0px' }}>
                <TableContainer component={Paper} className="scrollBlue" style={{ maxHeight: '60vh', marginBottom: '5px' }}>
                    <Table
                        stickyHeader
                        size="small"
                        aria-label="a dense table"
                        sx={{
                            '& .MuiTableCell-root': {
                                padding: '6px',
                                color: '#444',
                                lineHeight: 1
                            },
                        }}
                    >
                        <TableHead style={{ position: `sticky`, top: `0`, zIndex: '2', whiteSpace: 'pre' }}>
                            <TableRow>
                                {macManagement.map((col, index) => (
                                    <TableCell
                                        key={`TH-${index}`}
                                        style={{
                                            ...col.headerSx,
                                            backgroundColor: '#DAEDFE',
                                            height: '36px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            width: col.fixedWidth
                                                ? `${col.fixedWidth}px`
                                                : `${Math.ceil((width * col.widthPercent) / 100)}px`,
                                        }}
                                    >
                                        {col.headerName}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                {macManagement.map((col, index) =>
                                    col.showfilter ? (
                                        <TableCell key={`FTH-${index}`} sx={col?.headerSx}>
                                            <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                                <input
                                                    id={`index-${index}`}
                                                    className="field"
                                                    name="cancelSearchInput"
                                                    style={{ width: '100%' }}
                                                    placeholder={bum.contains || "Contains"}
                                                    onChange={(e) => handleChangeContain(e, col.field)}
                                                    onKeyDown={(e) => navigation1(e, index === 5 ? `index-1` : `index-${index + 1}`, index === 1 ? `index-5` : `index-${index - 1}`)}
                                                />
                                                <FilterAltIcon />
                                            </div>
                                        </TableCell>
                                    ) : (
                                        <TableCell key={`empty-cell-${index}`}></TableCell>
                                    )
                                )}
                            </TableRow>
                        </TableHead>
                        {filteredData?.length <= 0 ? (
                            <>
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={14}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '20px',
                                                    marginBottom: '20px',
                                                    color: 'red',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                <span>{bum.noResultsFoundPleaseRefineYourSearchParametersAndSearchAgain || 'No results found. Please refine your search parameters and search again.'}</span>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </>
                        ) : filteredData.length > 0 ? (
                            <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                                {filteredData?.map((item, index) => InsideRowContent(item, index))}
                            </TableBody>
                        ) : (
                            ''
                        )}
                    </Table>
                </TableContainer>
            </Box>
            {showConfirmation && <ShowMavenManagementConfirmation />}
            <SuccessAndErrorModal handleClose={() => { setIsSuccess(false); getTableData(); focusElemnt('mmBranchName') }} open={isSuccess} title={bum.macManagementStatusSavedSuccessfullyNl || 'Mac Management Status\n Saved Successfully'} modalStyle={modalStyle} />
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateAlertError, getAllBranchName, getMacManagementTableData, updateMacManagementStatus }
export default connect(mapStateToProps, mapDispatchToProps)(MacManagement)
